import { captureException } from '@sentry/browser';
var firstLoad = true;
/**
 * Creates routing instrumentation for Vue Router v2
 *
 * @param router The Vue Router instance that is used
 */
export function vueRouterInstrumentation(router) {
    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
        router.onError(function (error) { return captureException(error); });
        var tags = {
            'routing.instrumentation': 'vue-router',
        };
        router.beforeEach(function (to, _from, next) {
            var data = {
                params: to.params,
                query: to.query,
            };
            if (startTransactionOnPageLoad && firstLoad) {
                startTransaction({
                    name: to.name || to.path,
                    op: 'pageload',
                    tags: tags,
                    data: data,
                });
            }
            if (startTransactionOnLocationChange && !firstLoad) {
                startTransaction({
                    name: to.name || to.matched[0].path || to.path,
                    op: 'navigation',
                    tags: tags,
                    data: data,
                });
            }
            firstLoad = false;
            next();
        });
    };
}
//# sourceMappingURL=vuerouter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/vue/esm/vuerouter.js
// module id = 345
// module chunks = 1